import { createFileRoute, redirect } from '@tanstack/react-router';
import { learnArticleHref } from '~/content/learn';
import { getArticles } from '~/lib/payload';

/**
 * Legacy `/help/$slug` URLs redirect to the canonical Webflow path (`/article/$slug`,
 * `/bangladesh/$slug`, etc.) when a matching article exists.
 */
export const Route = createFileRoute('/help_/$slug')({
  loader: async ({ params }) => {
    const articles = await getArticles();
    const article = articles.find((item) => item.slug === params.slug);
    if (!article) throw redirect({ to: '/help' });
    throw redirect({ href: learnArticleHref(article) });
  },
  component: () => null,
});
